var App = App || {};

App.ScheduleAppointment = (() => {
    const init = () => {
        const bsModal = new bootstrap.Modal(document.getElementById('schedule-appointment-modal'));
        const forms = document.querySelectorAll('.schedule-appointment-form');
        const links = document.querySelectorAll('a[href="#schedule-appointment-modal"]');

        forms.forEach((form) => {
            const select = form.querySelector('.schedule-appointment-form__select');
            const button = form.querySelector('.schedule-appointment-form__proceed');

            select.addEventListener('change', event => {
                button.setAttribute('href', event.target.value);
                button.classList.remove('invisible');
            });

            button.addEventListener('click', () => {
                bsModal.hide();
            });
        });

        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                bsModal.show();
            });
        });
    }

    return {
        init: init
    };
})();